import styled from 'styled-components';

export const FormFooter = styled.div``;

export const FORM_FOOTER_SELECTOR = FormFooter.toString();
